import PropTypes from 'prop-types';
import React from 'react';
import {
  OPERANDS_BY_VALUE,
  DEFAULT_BY_COLUMN_TYPE,
  FILTER_TYPE,
} from 'constants/FilterConstants';
import constantObject from 'utilities/constantObject';
import ValueStep from './ValueStep';
import OperandStep from './OperandStep';
import ColumnStep from './ColumnStep';
import FilterEditorContainer from './FilterEditorContainer';
import {connect} from 'react-redux';
import {selectFilterableColumns} from 'state/dataSource/dataSourceSelectors';

const STEPS = constantObject(['COLUMN', 'OPERAND', 'VALUE']);

const matchingColumn = (filter, column) =>
  (filter.filterType === FILTER_TYPE.COLUMN_ID &&
    filter.column === column.id) ||
  (filter.filterType === FILTER_TYPE.NAME &&
    column.dataType === filter.dataType &&
    column.name === filter.column);

class PredicateEditor extends React.Component {
  state = {
    column: null,
    filterType: null,
    operand: OPERANDS_BY_VALUE.EQUALS,
    dataSourceId: null,
    values: [],
    selectedStep: STEPS.COLUMN,
  };

  componentDidMount() {
    this.reset(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.reset(nextProps);
  }

  reset({filter, columns}) {
    const column = columns.find(c => matchingColumn(filter, c));
    const operand =
      OPERANDS_BY_VALUE[filter.operand] ||
      DEFAULT_BY_COLUMN_TYPE[filter.dataType] ||
      OPERANDS_BY_VALUE.EQUALS;

    this.setState({
      column,
      operand,
      filterType: filter.filterType,
      values: filter.values || [],
      dataSourceId: filter.dataSourceId,
    });
  }

  handleColumnSelect = (column, dataSourceId, filterType) => {
    this.setState({
      column,
      filterType,
      dataSourceId,
      operand: DEFAULT_BY_COLUMN_TYPE[column.dataType],
      values: [],
    });
  };

  handleRemoveClick = () => {
    this.props.onRemove();
  };

  handleOperandSelect = operand => {
    this.setState({operand});
  };

  handleValuesChange = values => {
    this.setState({values});
  };

  handleStepClick = selectedStep => {
    this.setState({selectedStep});
  };

  handleApplyClick = () => {
    const {dataSourceId, column, filterType, operand, values} = this.state;
    this.props.onApply({
      id: this.props.filter.id,
      dataSourceId,
      values,
      column: filterType === FILTER_TYPE.COLUMN_ID ? column.id : column.name,
      label: column.name,
      operand: operand.value,
      dataType: column.dataType,
      filterType,
    });
  };

  render() {
    const {column, operand, values, selectedStep, dataSourceId} = this.state;
    const {columns, cardId, pageId} = this.props;
    const canApply = column && operand && values.some(Boolean);

    return (
      <FilterEditorContainer
        canRemove={true}
        onRemove={this.handleRemoveClick}
        canApply={canApply}
        onApply={this.handleApplyClick}
      >
        <ColumnStep
          column={column}
          columns={columns}
          onClick={this.handleStepClick.bind(this, STEPS.COLUMN)}
          onSelect={this.handleColumnSelect}
          selected={selectedStep === STEPS.COLUMN}
          dataSourceId={dataSourceId}
        />
        <OperandStep
          cardId={cardId}
          column={column}
          onClick={this.handleStepClick.bind(this, STEPS.OPERAND)}
          onSelect={this.handleOperandSelect}
          operand={operand}
          pageId={pageId}
          selected={selectedStep === STEPS.OPERAND}
        />
        <ValueStep
          cardId={cardId}
          column={column}
          dataSourceId={dataSourceId}
          onClick={this.handleStepClick.bind(this, STEPS.VALUE)}
          onValuesChange={this.handleValuesChange}
          pageId={pageId}
          selected={selectedStep === STEPS.VALUE}
          values={values}
        />
      </FilterEditorContainer>
    );
  }
}

PredicateEditor.propTypes = {
  filter: PropTypes.object.isRequired,
};

export default connect((state, {dataSourceIds}) => ({
  columns: selectFilterableColumns(state, dataSourceIds),
}))(PredicateEditor);
